/** Demo mode — tiles route to in-app demo product pages and a "DEMO"
 *  marker shows throughout. Enabled for the demo deploy; off in real prod. */
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true';
